import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import {
  StrapiEDTPays,
  StrapiEDT,
} from '@teetsh/app/src/containers/EmploiDuTemps/New/types';
import { ScholarSystemValue } from 'containers/scholarSystem';

export const EDT_TEMPLATES_KEY = 'edtTemplates';

type EdtFilters = {
  pays: StrapiEDTPays;
  scholarSystem: ScholarSystemValue;
};

function getEDTTemplates(filters: Partial<EdtFilters>) {
  const requestURL = '/cms/emplois-du-temps';
  const params: Record<string, string> = {};

  if (filters.pays) {
    params.pays = filters.pays;
  }

  if (filters.scholarSystem) {
    params.scholarSystem = filters.scholarSystem;
  }

  return request(requestURL, {
    method: 'GET',
    params,
  }).then<StrapiEDT[]>(({ data }) => data);
}

export default function useEDTTemplates(filters: Partial<EdtFilters>) {
  return useQuery({
    queryKey: [EDT_TEMPLATES_KEY],
    queryFn: () => getEDTTemplates(filters),
    placeholderData: undefined,
    staleTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
  });
}
